<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="amazonads"
      :logo="amazon"
      :success="success"
      :error="error"
      :logo-alt="$t('components.connectAmazonAds.amazonAdsLogo')"
      @click="openModal"
      @keyup.enter="openModal"
    />

    <!-- Amazon Modal -->
    <ModalAmazonads
      ref="amazonadsModal"
      :market="corpCountry"
      @submit="continueAmazonAdsIntegration"
      @error="$emit('error', MARKETING_PLATFORMS.AMAZONADS)"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
    />
  </span>
</template>

<script>
import { MARKETING_PLATFORMS } from '@/data/platforms';

import ModalAmazonads from '@/pages/connected-accounts/components/modals/ModalAmazonads.vue';
import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';

import amazonIcon from '@/assets/logos/amazon.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalAmazonads,
  },
  props: {
    corpCountry: String,
    authorizeUri: {
      type: String,
      required: true,
    },
    success: Boolean,
    error: Boolean,
  },
  computed: {
    amazon: () => amazonIcon,
    MARKETING_PLATFORMS: () => MARKETING_PLATFORMS,
  },
  methods: {
    openModal() {
      this.$refs.amazonadsModal.open();
    },
    continueAmazonAdsIntegration(amazonadsData) {
      this.$emit('submit', {
        authorizeUri: this.authorizeUri,
        extras: `${amazonadsData.sellerId},${amazonadsData.market}`,
      });
    },
  },
};
</script>
